import * as React from 'react'
import { useNavigate, useParams, useLocation } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import { Box, Drawer } from '@mui/material'
import { show, codeTree } from '../../redux/slices/Drawer/drawerRight'
import { updateFeatures } from '../../redux/slices/Tree/treeFeatures'
import { setIsStored } from '../../redux/slices/Alerts'
import { getPropertiesByID } from '../../services'
import { TREE } from '../../config/routeType'
import DrawerHeader from './DrawerHeader'
import Accordion from './Accordion'
import _ from 'lodash'

function getIndexOfFeature(codeId, data) {
  let idFeatureState = null
  data?.forEach((obj, key) => {
    if (obj.properties?.code === codeId) idFeatureState = key
  })
  return idFeatureState
}

const DrawerRightInfo = () => {
  let navigate = useNavigate()
  const dispatch = useDispatch()
  const { treeId: code } = useParams()
  const location = useLocation()
  const PROPERTIES_DEFAULT = 3

  const { value: open, index: idTreeInside } = useSelector(state => state.drawerRight)
  const stateDrawer = useSelector(state => state.drawerLeft)
  const { features } = useSelector(state => state.treeFeatures?.data)
  const treeFeature = features?.[idTreeInside]

  const handleCloseDrawerRight = () => {
    dispatch(show(false))
    dispatch(codeTree(null))
    navigate(`/${TREE}`)
  }

  React.useEffect(() => {
    if (!_.startsWith(location.pathname, `/${TREE}`)) return
    if (open) return
    if (idTreeInside) return
    if (!code) return
    if (!features.length) return

    const insideId = getIndexOfFeature(code, features)
    if (!insideId) {
      dispatch(setIsStored({ noCode: true }))
      return
    }
    getPropertiesByID(features[insideId].properties.id)
      .then(properties => {
        if (!Object.keys(properties).length > PROPERTIES_DEFAULT) {
          console.log('No se pudo cargar los datos. Intente más tarde.')
          return
        }
        dispatch(updateFeatures({ someId: insideId, someValue: properties }))
        dispatch(codeTree(insideId))
        dispatch(show(true))
      })
      .catch(err => console.log('Error :>> ', err))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [code, features])

  if (!open && !Boolean(treeFeature)) return

  return (
    <Box>
      <Drawer
        anchor="right"
        open={open}
        PaperProps={{
          sx: {
            top: stateDrawer.drawerHeight,
            height: stateDrawer.contentBox,
            minWidth: '334px',
            width: '25vw',
            backgroundColor: '#E7EBF0',
          },
        }}
        elevation={16}
        variant="persistent">
        <DrawerHeader
          scientificName={treeFeature?.properties?.specie?.name}
          commonName={treeFeature?.properties?.specie?.pseudonym?.[0]?.name}
          classifier={treeFeature?.properties?.specie?.classifier}
          onClick={handleCloseDrawerRight}
        />
        <Accordion data={treeFeature} />
      </Drawer>
    </Box>
  )
}
export default DrawerRightInfo
